import React from 'react';
export const DashLine = () => <div className="boder-[#D4D1D4] border-1 border-dashed" />;
